import { StoneXModal } from "../../../../StoneXMui";
import UpdatePositions from "./UpdatePositions";

interface UpdatePositionsModalProps {
  dealTicketId?: number;
  open: boolean;
  additionalCustomDataKeys?: string[];
  onClose: () => void;
  onCancel?: () => void;
  onSave: (dealTicketId: number) => void;
  onDelete: (dealTicketId: number) => void;
}

export function UpdatePositionsModal(props: UpdatePositionsModalProps) {

  const { dealTicketId, open, additionalCustomDataKeys, onClose, onSave, onDelete} = props;

  return <StoneXModal width='95%' header={dealTicketId ? 'Update Positions' : 'Add Positions'} open={open} onClose={onClose} sx={{maxWidth: '95%', maxHeight: '90%'}} height={'90%'}>
    <UpdatePositions dealTicketId={dealTicketId} additionalCustomDataKeys={additionalCustomDataKeys} onSave={onSave} onDelete={onDelete} onCancel={onClose}/>
  </StoneXModal>
}